import { Component, OnInit } from '@angular/core';
import { AppFilter, ConfirmModal, CommonServices } from 'src/modules/shared';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import {
  // AppropriationModal,
  // ProcurementTypeModal,
  SelectionMethodModal,
  AwardProjectModal,
  AwardLotModal,
} from 'src/modules/features/admin/modals';
import { MessageTemplateService } from 'src/modules/features/setting/services';
@Component({
  selector: 'app-account-list',
  templateUrl: './account-list.component.html',
  styleUrls: ['./account-list.component.scss'],
})
export class Step1Component implements OnInit {
  filter: AppFilter = new AppFilter();
  pending: boolean;
  totalItems: number = 5;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  projects: Array<any>;
  mpending: boolean;
  registrationSidebar;
  instruction;
  constructor(
    private modalService: SuiModalService,
    private commonSvc: CommonServices,
    private messageTemplateSvc: MessageTemplateService
  ) {
    this.commonSvc
      .getTemplate({ messageTemplateId: 'REGISTRATION_INSTRUCTIONS' })
      .subscribe((res: any) => {
        this.instruction = res.mailTemplate;
      });
    this.mpending = true;
    this.commonSvc
      .getTemplate({ messageTemplateId: 'CONTACT_SIDE_BAR' })
      .subscribe((res: any) => {
        this.registrationSidebar = res.mailTemplate;
        this.mpending = false;
      });
  }
  goBack() {}
  updateAppropriation() {
    // this.modalService
    // 	.open(
    // 		new AppropriationModal(
    // 			'Update Appropriation',
    // 			'Are you sure you want to delete this project plan?',
    // 			ModalSize.Tiny
    // 		)
    // 	)
    // 	.onApprove(() => {})
    // 	.onDeny(() => {});
  }

  updateProcurement() {
    // this.modalService
    // 	.open(
    // 		new ProcurementTypeModal(
    // 			'Update Procurement Type',
    // 			'Are you sure you want to delete this project plan?',
    // 			ModalSize.Tiny
    // 		)
    // 	)
    // 	.onApprove(() => {})
    // 	.onDeny(() => {});
  }

  updateSelection() {
    this.modalService
      .open(
        new SelectionMethodModal(
          'Update Selection Method',
          'Are you sure you want to delete this project plan?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {})
      .onDeny(() => {});
  }
  awardProject() {
    this.modalService
      .open(
        new AwardLotModal(
          'Select Lot',
          'Are you sure you want to delete this lot plan?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {})
      .onDeny(() => {});
  }
  selectTender() {
    // this.modalService
    // 	.open(new SelectLotModal('Select Lot', 'Are you sure you want to delete this lot plan?', ModalSize.Tiny))
    // 	.onApprove(() => {})
    // 	.onDeny(() => {});
  }
  delete() {
    this.modalService
      .open(
        new ConfirmModal(
          'Delete Lot plan?',
          'Are you sure you want to delete this lot plan?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {})
      .onDeny(() => {});
  }
  searchRecords(event) {}
  displayRecords(event) {}
  sortRecords(event) {}
  nextPage(event) {}
  viewProject(event) {}
  ngOnInit(): void {}
}
